/**
 * Asynchronously loads the component for notfoundpage
 */

import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "NotFoundPage" */ './index'), {
  fallback: <LoadingPage delay={1} />
})
